import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthenticationService } from '~/core/services/authentication.service';
import { RoutedDialogService } from '~/core/services/routed-dialog.service';

export function routedDialogGuard(routeType: 'deposit' | 'withdraw'): CanActivateFn {
  return async () => {
    const routedDialogService = inject(RoutedDialogService);
    const router = inject(Router);
    const auth = inject(AuthenticationService);

    if (routeType === 'deposit') {
      await routedDialogService.openDeposit();
    } else {
      await routedDialogService.openWithdraw();
    }

    if (auth.isLoggedIn()) {
      void router.navigate([''], { skipLocationChange: true });
    }

    return false;
  };
}
